import React from 'react';
import { useStore, isStashSeller } from '../../store/useStore';
import { ArrowLeft, CheckCircle2, AlertCircle, Info, ShieldCheck } from 'lucide-react';
import { StatusPill } from './Browse';
export function ProductDetail() {
  const {
    products,
    dispensaries,
    shopperSelectedProductId,
    setShopperView,
    reserveProduct
  } = useStore();
  const product = products.find(p => p.id === shopperSelectedProductId);
  if (!product) return null;
  const isStashed = product.status === 'Stashed';
  const isSeller = isStashSeller(products, dispensaries, product.dispensaryName);
  return <div className="flex flex-col h-full bg-white" data-id="element-441">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md p-4 flex items-center gap-4" data-id="element-442">
        <button onClick={() => setShopperView('Browse')} className="p-2 -ml-2 rounded-full hover:bg-gray-100 text-[#252935]" data-id="element-443">
          <ArrowLeft className="w-5 h-5" data-id="element-444" />
        </button>
        <h1 className="font-bold text-lg" data-id="element-445">Details</h1>
      </div>

      <div className="flex-1 overflow-y-auto" data-id="element-446">
        <img src={product.image} alt={product.name} onError={e => {
        e.currentTarget.src = 'https://images.unsplash.com/photo-1620912189865-1e8a32b1d6a2?auto=format&fit=crop&q=80&w=600&h=400';
      }} className="w-full h-64 object-cover bg-gray-100" data-id="element-447" />

        <div className="p-4" data-id="element-448">
          <div className="flex justify-between items-start mb-2" data-id="element-449">
            <h1 className="text-2xl font-bold text-[#252935] leading-tight" data-id="element-450">
              {product.name}
            </h1>
            <span className="text-2xl font-bold text-[#252935]" data-id="element-451">
              ${product.price}
            </span>
          </div>
          <div className="flex items-center gap-2 mb-4 flex-wrap" data-id="element-452">
            <p className="text-[#60646F]" data-id="element-453">
              {product.dispensaryName} • {product.distance} • {product.potency}
            </p>
            {isSeller && <span className="inline-flex items-center gap-1 text-[10px] font-bold text-[#007E7A] bg-[#E9FAF8] px-2 py-0.5 rounded-sm uppercase tracking-wider" data-id="element-454">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-455" />
                Stash Seller
              </span>}
          </div>

          <div className={`rounded-xl p-4 mb-6 ${isStashed ? 'bg-[#E9FAF8]' : 'bg-[#FFF8ED]'}`} data-id="element-456">
            <div className="flex items-center gap-2 mb-2" data-id="element-457">
              {isStashed ? <CheckCircle2 className="w-5 h-5 text-[#00CDBE]" data-id="element-458" /> : <AlertCircle className="w-5 h-5 text-[#C98A2E]" data-id="element-459" />}
              <h3 className={`font-bold ${isStashed ? 'text-[#007E7A]' : 'text-[#C98A2E]'}`} data-id="element-460">
                {isStashed ? 'Stashed.' : 'Not verified.'}
              </h3>
            </div>
            <p className={`text-sm ${isStashed ? 'text-[#007E7A]' : 'text-[#C98A2E]'}`} data-id="element-461">
              {isStashed ? `In stock, price locked, checked ${product.lastUpdated}.` : `Last updated ${product.lastUpdated}, check before you go.`}
            </p>
            {isStashed && <p className="text-sm text-[#007E7A] font-medium mt-2 pt-2 border-t border-[#00CDBE]/20" data-id="element-462">
                If it is wrong at pickup, we make it right.
              </p>}
          </div>

          <div className="space-y-4" data-id="element-463">
            <h3 className="font-bold text-[#252935]" data-id="element-464">About this product</h3>
            <p className="text-[#60646F] text-sm leading-relaxed" data-id="element-465">
              A classic strain known for its balanced effects. Perfect for
              daytime use and creative activities.
            </p>
          </div>
        </div>
      </div>

      <div className="shrink-0 p-4 bg-white border-t border-[rgba(37,41,53,0.12)]" data-id="element-466">
        <button onClick={() => reserveProduct(product.id)} className="w-full bg-[#00CDBE] text-white font-bold py-3.5 rounded-full mb-3 hover:bg-[#00B8AA] transition-colors" data-id="element-467">
          Reserve
        </button>
        {!isStashed && <p className="text-xs text-center text-[#60646F] mb-3" data-id="element-468">
            Note: This item is not covered by the Stash guarantee.
          </p>}
        <div className="relative flex justify-center group/how" data-id="element-469">
          <button type="button" className="flex items-center justify-center gap-1.5 text-sm font-medium text-[#007E7A] cursor-help focus:outline-none focus:underline" data-id="element-470">
            <Info className="w-4 h-4" data-id="element-471" />
            How Stash works
          </button>
          <span role="tooltip" className="pointer-events-none absolute bottom-full mb-2 w-64 rounded-lg bg-[#252935] p-3 text-xs leading-snug text-white text-center opacity-0 shadow-lg transition-opacity duration-150 group-hover/how:opacity-100 group-focus-within/how:opacity-100 z-40" data-id="element-472">
            Stash measures accuracy from real pickups. The badge is earned, not
            bought.
          </span>
        </div>
      </div>
    </div>;
}